const DEFAULT_LOCALE = "en"
const SUPPORTED_LOCALES = [
  "en",
  "pt",
  "es",
  "fr",
  "de",
  "ar",
  "it",
  "ja",
  "ko",
  "nl",
  "pl",
  "ru",
  "th",
  "vi",
  "zh",
]

module.exports = {
  DEFAULT_LOCALE,
  SUPPORTED_LOCALES,
}
